import {BBModel} from "../bb_model";
import {unwrapper} from "./uwrapper";

const base_login = {
    unwrap(resource) {
        return new BBModel.Admin.Login(resource);
    }
};

const login = {
    unwrap(resource) {
        return new BBModel.Admin.Login(resource);
    }
};

const schedule = {
    unwrap(resource) {
        return new BBModel.Admin.Schedule(resource);
    }
};

const administrators = {
    unwrap(resource) {
        return new Promise((resolve, reject) => {
            resource.$get('administrators').then((items) => {
                    const models = [];
                    for (const i of Array.from(items)) {
                        models.push(new BBModel.Admin.User(i));
                    }
                    return resolve(models);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    }
};

const companies = {
    unwrap(items) {
        return Array.from(items).map(i => new BBModel.Admin.Company(i));
    }
};

const company = {
    unwrap(resource) {
        return unwrapper.unwrapResource(BBModel.Admin.Company, resource);
    }
};

const people = {
    promise: true,
    unwrap(resource) {
        return new Promise((resolve, reject) => {
            resource.$get('people').then((items) => {
                    const models = [];
                    for (const i of Array.from(items)) {
                        models.push(new BBModel.Admin.Person(i));
                    }
                    return resolve(models);
                }
                , (err) => {
                    return reject(err);
                }
            );

        });
    }
};


const person = {
    unwrap(resource) {
        return new BBModel.Admin.Person(resource);
    }
};


const resource = {
    unwrap(resource) {
        return new BBModel.Admin.Resource(resource);
    }
};


const resources = {
    promise: true,
    unwrap(resource) {
        return new Promise((resolve, reject) => {
            resource.$get('resources').then((items) => {
                    const models = [];
                    for (const i of Array.from(items)) {
                        models.push(new BBModel.Admin.Resource(i));
                    }
                    return resolve(models);
                }
                , (err) => {
                    return reject(err);
                }
            );

        });
    }
};


const service = {
    unwrap(resource) {
        return new BBModel.Admin.Service(resource);
    }
};


const services = {
    promise: true,
    unwrap(resource) {
        return new Promise((resolve, reject) => {
            resource.$get('services').then((items) => {
                    const models = [];
                    for (const i of Array.from(items)) {
                        models.push(new BBModel.Admin.Service(i));
                    }
                    return resolve(models);
                }
                , (err) => {
                    return reject(err);
                }
            );

        });
    }
};

const conversation = {
    unwrap(conversation) {
        return new BBModel.Conversation(conversation);
    }
};

const message = {
    promise: true,
    unwrap(conversation) {
        return unwrapper.unwrapCollection(BBModel.Message, 'messages', conversation);
    }
};

export {
    administrators,
    base_login,
    companies,
    company,
    conversation,
    login,
    message,
    people,
    person,
    resource,
    resources,
    service,
    services,
    schedule
};
